<template>
	<section>
		<Title
			title="Sprachen"
			:completion-type="completionType"
			parent
			@edit="edit"
		/>
		<div>
			<SelectedItems
				:selected="value"
				:characteristic-items="meta.language"
				class="no-left-padding"
				:specificities-provider="itemSpecificitiesProvider"
				:label-appendix-provider="labelAppendixProvider"
			/>
		</div>
	</section>
</template>

<script>
import Title from "@/vue/common/profile-view/Title.vue";
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";
import _ from "lodash";
import {LANGUAGE_MOTHER} from "@/helper/job-profile/SpecificityType";
import {LANGUAGE_MOTHER_YES} from "@/helper/characteristic/NaturalId";
import {sort} from "@/helper/characteristic/specificity/Sort";
import {mapActions} from "vuex";

export default {
	components: {
		SelectedItems,
		Title
	},

	props: {
		value: {
			type: Array,
			required: false,
		},
		meta: {
			type: Object,
			required: true,
		},
		completionType: {
			type: String,
			required: true,
		},
	},

	methods: {
		...mapActions('application/language/fan', {
			openFan: 'show'
		}),
		labelAppendixProvider ({item})
		{
			let appendix = undefined;

			_.forEach(item.specificities, allocation =>
			{
				if (allocation.specificityType.id === LANGUAGE_MOTHER)
				{
					appendix = allocation.specificity.naturalId === LANGUAGE_MOTHER_YES
						? '(Muttersprache)'
						: '(Fremdsprache)';
				}
			});

			return appendix;
		},
		itemSpecificitiesProvider ({item})
		{
			let elements = [];

			const specificities = sort({
				specificities: item.specificities,
				characteristicType: this.meta.languageType
			});

			_.forEach(specificities, allocation =>
			{
				if (allocation.specificityType.id === LANGUAGE_MOTHER)
				{
					return true; // continue
				}

				elements.push({
					label: allocation.specificityType.label,
					value: allocation.specificity.label
				});
			});

			return elements;
		},
		edit ()
		{
			this.openFan({
				languages: this.value,
				onClose: data =>
				{
					if (!data.confirmed || !data.languages)
					{
						return;
					}

					this.$emit('input', data.languages);
					this.$emit('change', {
						items: data.languages,
						skipped: data.skipped
					});
				}
			});
		}
	},
}
</script>
